import { useEffect, useState } from "react";

export const useSwiper = ({ containerRef, trackRef, cardClassName, gap = 16, breakpoints }) => {
  const [cardWidth, setCardWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const [mode, setMode] = useState("translate");
  
  useEffect(() => {
    const handleResize = () => {
      const container = containerRef.current;

      if (!container) return;
      
      const containerWidth = container.getBoundingClientRect().width;
      const screenWidth = window.innerWidth;
      
      let itemsPerView = 1;
      let matchedBp = null;
      
      if (breakpoints?.length > 0) {
        const sorted = [...breakpoints].sort((a, b) => a.width - b.width);
        
        for (const bp of sorted) {
          if (screenWidth >= bp.width) matchedBp = bp;
        }
      }
      
      if (matchedBp?.items === "scroll") {
        setMode("scroll");
        setCardWidth("auto");

        return;
      }
      
      itemsPerView = typeof matchedBp?.items === "number" ? matchedBp.items : 1;
      setMode("translate");
      
      const totalGap = itemsPerView > 1 ? (itemsPerView - 1) * gap : 0;
      const calculatedCardWidth = (containerWidth - totalGap) / itemsPerView;
      
      setCardWidth(calculatedCardWidth);
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoints, containerRef, gap]);
  
  
  const updateLimits = (nextOffset) => {
    const container = containerRef.current;
    const track = trackRef.current;

    if (!container || !track) return;
    
    const maxOffset = track.scrollWidth - container.offsetWidth;

    setAtStart(nextOffset <= 0);
    setAtEnd(nextOffset >= maxOffset - 1);
  };
  
  const scrollBy = (direction) => {
    if (mode === "scroll") return;
    
    const card = trackRef.current?.querySelector(`.${cardClassName}`);
    const container = containerRef.current;

    if (!card || !container) return;
    
    const scrollAmount = card.offsetWidth + gap;
    const delta = direction === "right" ? scrollAmount : -scrollAmount;
    
    const maxOffset = trackRef.current.scrollWidth - container.offsetWidth;
    
    let nextOffset = offset + delta;
    nextOffset = Math.max(0, Math.min(maxOffset, nextOffset));
    
    setOffset(nextOffset);
    updateLimits(nextOffset);
  };
  
  return { cardWidth,  offset,  scrollBy,  atStart,  atEnd,  mode, width: window.innerWidth };
};
